module.exports = __webpack_public_path__ + "img/T2B_xh_13.9be6cd7f.png";